import React, { useState } from 'react';
import taskService from '../../services/taskService';
import '../../assets/styles/Workflow.css';

interface QaReviewModalProps {
  qaTaskId: number;
  projectSummary: string;
  onClose: () => void;
  onApproved: () => void;
}

const QaReviewModal: React.FC<QaReviewModalProps> = ({ qaTaskId, projectSummary, onClose, onApproved }) => {
  // Decorative-only checklist state, mirrors the prototype exactly: no onChange
  // handler there either, so nothing here is persisted or sent to the backend.
  const [dedupChecked] = useState(true);
  const [fieldsChecked] = useState(true);
  const [sampleChecked] = useState(false);
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleApprove = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await taskService.updateTaskStatus(qaTaskId, 'qa_complete');
      onApproved();
      onClose();
    } catch (err: any) {
      setError((err?.response?.data?.message || err?.response?.message) || 'Failed to mark QA complete');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="wf-overlay">
      <div className="wf-modal">
        <div className="wf-modal-head">
          <h2 style={{ fontSize: 17 }}>QA review - {projectSummary}</h2>
          <button className="wf-iconbtn" onClick={onClose}>✕</button>
        </div>
        <div className="wf-modal-body">
          <div className="wf-stack">
            <label className="wf-checkrow">
              <input type="checkbox" checked={dedupChecked} readOnly /> De-duplication requirement satisfied
            </label>
            <label className="wf-checkrow">
              <input type="checkbox" checked={fieldsChecked} readOnly /> All requested data fields present
            </label>
            <label className="wf-checkrow">
              <input type="checkbox" checked={sampleChecked} readOnly /> 10% sample spot-check against source criteria
            </label>
            <div>
              <label className="wf-field-label">QA notes</label>
              <textarea
                rows={4}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Optional notes for the fulfillment team"
              />
              <div className="wf-field-hint">Not saved yet — QA notes aren't persisted by the backend.</div>
            </div>
          </div>
          {error && <div style={{ color: '#ef4444', fontSize: 13, marginTop: 12 }}>{error}</div>}
        </div>
        <div className="wf-modal-foot" style={{ justifyContent: 'flex-end' }}>
          <button className="wf-btn wf-btn-primary" disabled={submitting} onClick={handleApprove}>
            {submitting ? 'Submitting...' : 'Approve - Mark QA Complete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QaReviewModal;
